export interface FilterValues {
    abrJahr: number;
    abrMo: number;
    currentMonth: boolean;
    betreuer?: number;
    showFAnteil: boolean;
}

export interface LineData {
    rNr: string;
    auNr: string;
    kNr: number;
    kName: string;
    datum: string;
    bezDat: string;
    count: number;
    betreuerNr: number;
    name: string;
    ekNetto: number;
    vkNetto: number;
    bMarge: number;
    tippProv: number;
    skonto: number;
    fracht: number;
    nMarge: number;
    bAnteil: number;
    fAnteil: number;
    betrUmCount: number;
    betrUm: number;
}

export const defaultLineData: LineData = {
    rNr: '',
    auNr: '',
    kNr: 0,
    kName: '',
    datum: '',
    bezDat: '',
    betreuerNr: 0,
    count: 0,
    name: '',
    ekNetto: 0,
    vkNetto: 0,
    bMarge: 0,
    tippProv: 0,
    skonto: 0,
    fracht: 0,
    nMarge: 0,
    bAnteil: 0,
    fAnteil: 0,
    betrUmCount: 0,
    betrUm: 0,
};

export interface RechnungSummary {
    loading: boolean;
    count: number;
    total: LineData;
    // betreuerTotal: LineData;
    betreuerTotal: {
        [key: number]: LineData;
    };
    rechnungLineDataList: LineData[];
    fAnteilTotal: number;
    finish: () => void;
}
